var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseGreen32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.707 11.707a1 1 0 00-1.414-1.414l1.414 1.414zm-11.414 8.586a1 1 0 101.414 1.414l-1.414-1.414zm10-10l-10 10 1.414 1.414 10-10-1.414-1.414z",
    fill: "#31BEA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 11.707a1 1 0 111.414-1.414l-1.414 1.414zm11.414 8.586a1 1 0 01-1.414 1.414l1.414-1.414zm-10-10l10 10-1.414 1.414-10-10 1.414-1.414z",
    fill: "#31BEA5"
  })));
}

export default SvgCloseGreen32;